
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a197024196 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":"’","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a372273988 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":"’","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a837628944 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":"’","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1872765335 = numberParserFn([{".":".","’":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1385278712 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a1273671099 = messageFormatterFn((function(  ) {
  return function(d) { return "Viaggi: vacanze, voli economici, biglietti e tariffe aeree"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1193023587 = messageFormatterFn((function(  ) {
  return function(d) { return "Punti utilizzati"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2115673408 = messageFormatterFn((function(  ) {
  return function(d) { return "Non verranno utilizzati punti"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a27742084 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi la finestra pop-up"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a348936391 = messageFormatterFn((function(  ) {
  return function(d) { return "Dove"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b596101357 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b802157148 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1738835857 = messageFormatterFn((function(  ) {
  return function(d) { return "Data"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1447125189 = messageFormatterFn((function(  ) {
  return function(d) { return "Persone"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a380841825 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a325601003 = messageFormatterFn((function(  ) {
  return function(d) { return "Maggiori informazioni su " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a841637896 = messageFormatterFn((function(  ) {
  return function(d) { return "Apertura di " + d["0"] + " in una nuova finestra, torna alla scheda originale per proseguire"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2097353699 = messageFormatterFn((function(  ) {
  return function(d) { return "Risultati della ricerca"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1762212556 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una destinazione"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a296322714 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una data di check-in valida"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a264641893 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona le date per il tuo viaggio"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a730981003 = messageFormatterFn((function(  ) {
  return function(d) { return "La data di check-out deve essere successiva a quella di check-in"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1667096493 = messageFormatterFn((function(  ) {
  return function(d) { return "La data di check-out deve essere entro 28 giorni da quella di check-in"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1616028201 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una data di check-out valida"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2127208727 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona il numero di viaggiatori"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1558646496 = messageFormatterFn((function(  ) {
  return function(d) { return "Indica l’età del bambino"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b199061264 = messageFormatterFn((function(  ) {
  return function(d) { return "Indica l’età dei bambini"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b664345586 = messageFormatterFn((function(  ) {
  return function(d) { return "Le date del soggiorno devono essere comprese tra quelle del viaggio"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b136292621 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1201392443 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " camere";}, one: function() { return number(d["0"]) + " camera";}, two: function() { return number(d["0"]) + " camere";}, few: function() { return number(d["0"]) + " camere";}, many: function() { return number(d["0"]) + " camere";}, other: function() { return number(d["0"]) + " camere";} }) + ", " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]) + " persone";}, one: function() { return number(d["1"]) + " persona";}, two: function() { return number(d["1"]) + " persone";}, few: function() { return number(d["1"]) + " persone";}, many: function() { return number(d["1"]) + " persone";}, other: function() { return number(d["1"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1277923317 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]) + " persone";}, one: function() { return number(d["1"]) + " persona";}, two: function() { return number(d["1"]) + " persone";}, few: function() { return number(d["1"]) + " persone";}, many: function() { return number(d["1"]) + " persone";}, other: function() { return number(d["1"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1284857805 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]) + " persone";}, one: function() { return number(d["1"]) + " persona";}, two: function() { return number(d["1"]) + " persone";}, few: function() { return number(d["1"]) + " persone";}, many: function() { return number(d["1"]) + " persone";}, other: function() { return number(d["1"]) + " persone";} }) + ", animali domestici"; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a1537712338 = messageFormatterFn((function(  ) {
  return function(d) { return "Persone"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1847544134 = messageFormatterFn((function(  ) {
  return function(d) { return "Camera " + d["0"] + " aggiunta. Modifica le informazioni sugli ospiti."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1694788698 = messageFormatterFn((function(  ) {
  return function(d) { return "Camera rimossa. Modifica le informazioni sugli ospiti della camera " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1524165066 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulla e chiudi la finestra viaggiatore senza salvare le modifiche. O modifica le informazioni sugli ospiti."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1120875914 = messageFormatterFn((function(  ) {
  return function(d) { return "Fatto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a575659390 = messageFormatterFn((function(  ) {
  return function(d) { return "Salva le modifiche e chiudi la finestra viaggiatore."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a321692078 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiungi un’altra camera"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1843972365 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi camera"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a218219387 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi camera " + d["0"] + " di " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1070065799 = messageFormatterFn((function(  ) {
  return function(d) { return "Età bambino " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a984739361 = messageFormatterFn((function(  ) {
  return function(d) { return "Camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b236136320 = messageFormatterFn((function(  ) {
  return function(d) { return "Camera " + d["0"] + " di " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b120708866 = messageFormatterFn((function(  ) {
  return function(d) { return "Bambino " + d["0"] + ", età modificata a " + d["1"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1516981212 = messageFormatterFn((function(  ) {
  return function(d) { return "Meno di 1 anno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1696943670 = messageFormatterFn((function(  ) {
  return function(d) { return "Bambini"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1425598035 = messageFormatterFn((function(  ) {
  return function(d) { return "(0-17)"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1596717740 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " adulti";}, one: function() { return number(d["0"]) + " adulto";}, two: function() { return number(d["0"]) + " adulti";}, few: function() { return number(d["0"]) + " adulti";}, many: function() { return number(d["0"]) + " adulti";}, other: function() { return number(d["0"]) + " adulti";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b71197734 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " bambini";}, one: function() { return number(d["0"]) + " bambino";}, two: function() { return number(d["0"]) + " bambini";}, few: function() { return number(d["0"]) + " bambini";}, many: function() { return number(d["0"]) + " bambini";}, other: function() { return number(d["0"]) + " bambini";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a1790295228 = messageFormatterFn((function(  ) {
  return function(d) { return "Adulti"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1700265656 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi bambini dalla camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b109140546 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi adulti dalla camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1828483948 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiungi bambini nella camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1563163290 = messageFormatterFn((function(  ) {
  return function(d) { return "Aggiungi adulti nella camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1721141382 = messageFormatterFn((function(  ) {
  return function(d) { return "Animali domestici"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b477094634 = messageFormatterFn((function(  ) {
  return function(d) { return "Gli animali domestici sono inclusi?"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a185878538 = messageFormatterFn((function(  ) {
  return function(d) { return "Sì"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b926004036 = messageFormatterFn((function(  ) {
  return function(d) { return "No"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a276791558 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbiamo aggiunto " + d["0"] + " alle tue liste"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1006538944 = messageFormatterFn((function(  ) {
  return function(d) { return "Apertura in un’altra finestra"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1093977003 = messageFormatterFn((function(  ) {
  return function(d) { return "Recensioni degli ospiti"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b353705859 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancella, torna ai dettagli dell’hotel."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b102559237 = messageFormatterFn((function(  ) {
  return function(d) { return "Controlla disponibilità"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b484840922 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1503835404 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifica ricerca"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1832258793 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una data di check-in successiva"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1408275131 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una data di check-in precedente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1420698646 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una data di check-out successiva"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1819835278 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona una data di check-out precedente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1654140884 = messageFormatterFn((function(  ) {
  return function(d) { return "Il prezzo era " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a134837914 = messageFormatterFn((function(  ) {
  return function(d) { return "Il prezzo è " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a668507071 = messageFormatterFn((function(  ) {
  return function(d) { return "Il prezzo attuale è " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a346361421 = messageFormatterFn((function(  ) {
  return function(d) { return "Il prezzo era " + d["0"] + ", ora è " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1282215290 = messageFormatterFn((function(  ) {
  return function(d) { return "a notte"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1663423370 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancella, torna ai dettagli dell’hotel."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a86694478 = messageFormatterFn((function(  ) {
  return function(d) { return "Più dettagli"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1977816920 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi, torna ai dettagli dell’hotel."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b3125630 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un errore."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b116258884 = messageFormatterFn((function(  ) {
  return function(d) { return "Ripeti la ricerca."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1238873668 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra opzioni e prenota"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1645977705 = messageFormatterFn((function(  ) {
  return function(d) { return "Potrebbero interessarti anche"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a391250076 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi filtri"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1046507740 = messageFormatterFn((function(  ) {
  return function(d) { return "Ordina e filtra"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1267569862 = messageFormatterFn((function(  ) {
  return function(d) { return "Fatto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1533927375 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulla"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b130870584 = messageFormatterFn((function(  ) {
  return function(d) { return "Clicca su imposta o torna a chiudi filtri"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1494868662 = messageFormatterFn((function(  ) {
  return function(d) { return "Prezzo minimo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1920941020 = messageFormatterFn((function(  ) {
  return function(d) { return "Prezzo massimo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1396917473 = messageFormatterFn((function(  ) {
  return function(d) { return "Classificazione per stelle"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b520107410 = messageFormatterFn((function(  ) {
  return function(d) { return "Ordina per"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b538101007 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtra per"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a556547505 = messageFormatterFn((function(  ) {
  return function(d) { return "Torna alla ricerca hotel"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1166369447 = messageFormatterFn((function(  ) {
  return function(d) { return "Stiamo cercando tra migliaia di strutture"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2115170594 = messageFormatterFn((function(  ) {
  return function(d) { return "Ricerca in corso su migliaia di offerte per pacchetti"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a639964822 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Hai applicato " + plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " filtri";}, one: function() { return number(d["0"]) + " filtro";}, two: function() { return number(d["0"]) + " filtri";}, few: function() { return number(d["0"]) + " filtri";}, many: function() { return number(d["0"]) + " filtri";}, other: function() { return number(d["0"]) + " filtri";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1979997546 = messageFormatterFn((function(  ) {
  return function(d) { return "Ordina e filtra"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2030046582 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtra"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b11473097 = messageFormatterFn((function(  ) {
  return function(d) { return "Mappa"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b283665580 = messageFormatterFn((function(  ) {
  return function(d) { return "caricamento risultati"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b69153291 = messageFormatterFn((function(  ) {
  return function(d) { return "risultati aggiornati"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1730519739 = messageFormatterFn((function(  ) {
  return function(d) { return "errore durante il caricamento dei risultati"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1407199857 = messageFormatterFn((function(  ) {
  return function(d) { return "nessun risultato"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1351283217 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca hotel"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1532688510 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a548849239 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova con queste date"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b368863281 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra altre date"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b406684397 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra meno date"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a479721628 = messageFormatterFn((function(  ) {
  return function(d) { return "Risultati della ricerca hotel per " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a951177792 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": risultati della ricerca di case vacanze"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1672141711 = messageFormatterFn((function(  ) {
  return function(d) { return "Risultati della ricerca hotel non validi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1648465839 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra altro"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b734874327 = messageFormatterFn((function(  ) {
  return function(d) { return "Spiacenti, non abbiamo trovato alcun risultato. Prova a modificare i criteri di ricerca."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1169821773 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtro selezionato"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b778105873 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtri selezionati"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b161279249 = messageFormatterFn((function(  ) {
  return function(d) { return "Destinazione non inserita"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1678936069 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2043125861 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi tutti i filtri"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a208803034 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " persone";}, one: function() { return number(d["0"]) + " persona";}, two: function() { return number(d["0"]) + " persone";}, few: function() { return number(d["0"]) + " persone";}, many: function() { return number(d["0"]) + " persone";}, other: function() { return number(d["0"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a60711282 = messageFormatterFn((function(  ) {
  return function(d) { return "Spiacenti, si sta verificando un problema"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1649248833 = messageFormatterFn((function(  ) {
  return function(d) { return "Riprova"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1327993943 = messageFormatterFn((function(  ) {
  return function(d) { return "Salva " + d["0"] + " nelle tue liste"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a636259789 = messageFormatterFn((function(  ) {
  return function(d) { return "Elimina " + d["0"] + " dalle tue liste"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1823942389 = messageFormatterFn((function(  ) {
  return function(d) { return "Dettagli del soggiorno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a878113420 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca in questa zona"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a708145702 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un errore. Prova ad eseguire nuovamente la ricerca."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1689259841 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi mappa"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a281214327 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " strutture";}, one: function() { return number(d["0"]) + " struttura";}, two: function() { return number(d["0"]) + " strutture";}, few: function() { return number(d["0"]) + " strutture";}, many: function() { return number(d["0"]) + " strutture";}, other: function() { return number(d["0"]) + " strutture";} }) + "\nda " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b727365024 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " strutture";}, one: function() { return number(d["0"]) + " struttura";}, two: function() { return number(d["0"]) + " strutture";}, few: function() { return number(d["0"]) + " strutture";}, many: function() { return number(d["0"]) + " strutture";}, other: function() { return number(d["0"]) + " strutture";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1857565881 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra altro"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b481168806 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra meno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1628528632 = messageFormatterFn((function(  ) {
  return function(d) { return "Spiacenti, si è verificato un problema"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1288980292 = messageFormatterFn((function(  ) {
  return function(d) { return "Elemento successivo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b899360056 = messageFormatterFn((function(  ) {
  return function(d) { return "Elemento precedente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b441355029 = messageFormatterFn((function(  ) {
  return function(d) { return "Procedi al pagamento"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1135384820 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Il tuo viaggio (" + plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " camere";}, one: function() { return number(d["0"]) + " camera";}, two: function() { return number(d["0"]) + " camere";}, few: function() { return number(d["0"]) + " camere";}, many: function() { return number(d["0"]) + " camere";}, other: function() { return number(d["0"]) + " camere";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1755266485 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Il tuo viaggio (" + plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " alloggi";}, one: function() { return number(d["0"]) + " alloggio";}, two: function() { return number(d["0"]) + " alloggi";}, few: function() { return number(d["0"]) + " alloggi";}, many: function() { return number(d["0"]) + " alloggi";}, other: function() { return number(d["0"]) + " alloggi";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1150623791 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona la prossima camera"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1015311598 = messageFormatterFn((function(  ) {
  return function(d) { return "Non più disponibile"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2007605574 = messageFormatterFn((function(  ) {
  return function(d) { return "Una o più strutture che avevi scelto non sono più disponibili. Vuoi andare comunque alla pagina di pagamento?"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a904310157 = messageFormatterFn((function(  ) {
  return function(d) { return "a camera"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2087849045 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " persone";}, one: function() { return number(d["0"]) + " persona";}, two: function() { return number(d["0"]) + " persone";}, few: function() { return number(d["0"]) + " persone";}, many: function() { return number(d["0"]) + " persone";}, other: function() { return number(d["0"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b784436295 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " camere";}, one: function() { return number(d["0"]) + " camera";}, two: function() { return number(d["0"]) + " camere";}, few: function() { return number(d["0"]) + " camere";}, many: function() { return number(d["0"]) + " camere";}, other: function() { return number(d["0"]) + " camere";} }) + ", " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]) + " persone";}, one: function() { return number(d["1"]) + " persona";}, two: function() { return number(d["1"]) + " persone";}, few: function() { return number(d["1"]) + " persone";}, many: function() { return number(d["1"]) + " persone";}, other: function() { return number(d["1"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a1522584262 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/a notte"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1326130866 = messageFormatterFn((function(  ) {
  return function(d) { return "Cambia camera"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b746948478 = messageFormatterFn((function(  ) {
  return function(d) { return "Codice copiato negli appunti."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b969618597 = messageFormatterFn((function(  ) {
  return function(d) { return "Spiacenti, si sta verificando un problema"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a658116772 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova a ripetere la ricerca"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a547767694 = messageFormatterFn((function(  ) {
  return function(d) { return "Riprova"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1970550469 = messageFormatterFn((function(  ) {
  return function(d) { return "Ritiro e riconsegna dell’auto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1455332494 = messageFormatterFn((function(  ) {
  return function(d) { return "Orario del ritiro"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1642948666 = messageFormatterFn((function(  ) {
  return function(d) { return "Tempo per la riconsegna"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a912493529 = messageFormatterFn((function(  ) {
  return function(d) { return "Noleggio auto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b427738682 = messageFormatterFn((function(  ) {
  return function(d) { return "L’orario di riconsegna deve essere di almeno 2 ore successivo a quello di ritiro"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1835557134 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1835467761 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1834633613 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1834544240 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1833710092 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1833620719 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1832786571 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1832697198 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1831863050 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1831773677 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1830939529 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1830850156 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1830016008 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1829926635 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1829092487 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1829003114 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1828168966 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1828079593 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1827245445 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1827156072 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1806927983 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1806838610 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1806004462 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1805915089 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1805080941 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1804991568 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1804157420 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1804068047 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1803233899 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1803144526 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1802310378 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1802221005 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1801386857 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1801297484 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1800463336 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1800373963 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1799539815 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1799450442 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1798616294 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1798526921 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1778298832 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1778209459 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1777375311 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1777285938 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1776451790 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1776362417 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1775528269 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1775438896 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a26929715 = messageFormatterFn((function(  ) {
  return function(d) { return "Solo voli diretti"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1626344902 = messageFormatterFn((function(  ) {
  return function(d) { return "Classe di viaggio preferita"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b584773906 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2137793447 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium economy"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b59167758 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b610897766 = messageFormatterFn((function(  ) {
  return function(d) { return "Prima classe"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b859037327 = messageFormatterFn((function(  ) {
  return function(d) { return "Persone"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1332877745 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve esserci almeno 1 viaggiatore (da 6 anni in su) per ogni bambino portato in braccio."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b904958740 = messageFormatterFn((function(  ) {
  return function(d) { return "Neonati"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1202566539 = messageFormatterFn((function(  ) {
  return function(d) { return "(2-17)"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b574307363 = messageFormatterFn((function(  ) {
  return function(d) { return "Meno di 2 anni"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a103258453 = messageFormatterFn((function(  ) {
  return function(d) { return "Età del neonato " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b606994969 = messageFormatterFn((function(  ) {
  return function(d) { return "Riduci il numero dei neonati in questa camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1564745923 = messageFormatterFn((function(  ) {
  return function(d) { return "Aumenta il numero dei neonati in questa camera " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b776743851 = messageFormatterFn((function(  ) {
  return function(d) { return "I bambini di età inferiore ai 2 anni devono sedere su un seggiolino o stare in braccio a un adulto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1165226045 = messageFormatterFn((function(  ) {
  return function(d) { return "In braccio"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1213960325 = messageFormatterFn((function(  ) {
  return function(d) { return "Con posto a sedere"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1181581254 = messageFormatterFn((function(  ) {
  return function(d) { return "Requisiti di età della compagnia aerea"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a767627642 = messageFormatterFn((function(  ) {
  return function(d) { return "Città di partenza"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1107256958 = messageFormatterFn((function(  ) {
  return function(d) { return "Andata"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1068354626 = messageFormatterFn((function(  ) {
  return function(d) { return "Ritorno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b979447588 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona un’origine"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1082703222 = messageFormatterFn((function(  ) {
  return function(d) { return "Ho bisogno di una sistemazione solo per parte del viaggio"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a375160265 = messageFormatterFn((function(  ) {
  return function(d) { return "Siamo spiacenti, si è verificato un problema. Riprova."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a703542123 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona almeno 1 struttura da confrontare"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1954300792 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Strutture selezionate: " + d["0"] + " su " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]);}, one: function() { return number(d["1"]);}, two: function() { return number(d["1"]);}, few: function() { return number(d["1"]);}, many: function() { return number(d["1"]);}, other: function() { return number(d["1"]);} }) + " "; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1629232732 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Strutture selezionate per il confronto: " + d["0"] + " su " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]);}, one: function() { return number(d["1"]);}, two: function() { return number(d["1"]);}, few: function() { return number(d["1"]);}, many: function() { return number(d["1"]);}, other: function() { return number(d["1"]);} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1278884302 = messageFormatterFn((function(  ) {
  return function(d) { return "Confronta"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1734278358 = messageFormatterFn((function(  ) {
  return function(d) { return "Confronta le strutture selezionate"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a260198084 = messageFormatterFn((function(  ) {
  return function(d) { return "Confronta"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1050478040 = messageFormatterFn((function(  ) {
  return function(d) { return "Confronta le strutture selezionate"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b943201206 = messageFormatterFn((function(  ) {
  return function(d) { return "Visualizza"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a271971346 = messageFormatterFn((function(  ) {
  return function(d) { return "Clicca qui per visualizzare la struttura"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1885424663 = messageFormatterFn((function(  ) {
  return function(d) { return "Elimina"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a144379859 = messageFormatterFn((function(  ) {
  return function(d) { return "Clicca qui per eliminare la struttura dal confronto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1123852727 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi la sezione del confronto tra strutture"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1655985859 = messageFormatterFn((function(  ) {
  return function(d) { return "Confronta strutture"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1165712884 = messageFormatterFn((function(  ) {
  return function(d) { return "Visualizza fino a 5 strutture insieme e scegli quella che fa per te. Per iniziare, clicca su \"Confronta\"."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1777535752 = messageFormatterFn((function(  ) {
  return function(d) { return "Visualizza fino a 5 strutture insieme e scegli quella che fa per te."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1168117584 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova subito"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1852081452 = messageFormatterFn((function(  ) {
  return function(d) { return "Inizia subito"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a144495416 = messageFormatterFn((function(  ) {
  return function(d) { return "Disattiva il confronto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a184215884 = messageFormatterFn((function(  ) {
  return function(d) { return "Forse più tardi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1475142775 = messageFormatterFn((function(  ) {
  return function(d) { return "Confronta strutture"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b926318222 = messageFormatterFn((function(  ) {
  return function(d) { return "Per iniziare, clicca su \"Confronta\" nei risultati di ricerca."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1348731474 = messageFormatterFn((function(  ) {
  return function(d) { return "Visualizza fino a 5 strutture insieme."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1374481403 = messageFormatterFn((function(  ) {
  return function(d) { return "Nessuna disponibilità in data " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1576631832 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out non disponibile in data " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a570076615 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in non disponibile in data " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1045855385 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b289586298 = messageFormatterFn((function(  ) {
  return function(d) { return "Personalizza il tuo soggiorno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1884198694 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi la sezione per personalizzare il tuo soggiorno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1389738424 = messageFormatterFn((function(  ) {
  return function(d) { return "Chiudi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1348160192 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulla"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a839654682 = messageFormatterFn((function(  ) {
  return function(d) { return "Ignora"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b290570488 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1737808694 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2044400031 = messageFormatterFn((function(  ) {
  return function(d) { return "selezionato"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2078828364 = messageFormatterFn((function(  ) {
  return function(d) { return "Caricamento in corso…"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1399497379 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancella"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1283009943 = messageFormatterFn((function(  ) {
  return function(d) { return "Apertura in un’altra finestra"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2027659663 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra altro"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b866861314 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra meno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b634551898 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra altro"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2120095501 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra meno"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a704159448 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + ". Ora scegli una data di check-out."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1373977273 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + ". Ora clicca su " + d["1"] + " per salvare queste date e chiudere il calendario."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b407719907 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato il giorno " + d["0"] + ". Data di check-in attuale."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a987611172 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato il giorno " + d["0"] + ". Data di check-out attuale."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1601616250 = messageFormatterFn((function(  ) {
  return function(d) { return "data disabilitata " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1001733687 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", mese corrente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a491940750 = messageFormatterFn((function(  ) {
  return function(d) { return "Scheda attuale: " + d["0"] + " e " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b819303854 = messageFormatterFn((function(  ) {
  return function(d) { return "Apertura calendario. Seleziona una data dalla tabella in basso."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b465910660 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancella, chiudi il calendario senza salvare le modifiche. O seleziona una data dalla tabella in basso."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a601389524 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi le date selezionate"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1884169335 = messageFormatterFn((function(  ) {
  return function(d) { return "Salva le modifiche e chiudi il calendario."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1110245968 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " notti";}, one: function() { return number(d["0"]) + " notte";}, two: function() { return number(d["0"]) + " notti";}, few: function() { return number(d["0"]) + " notti";}, many: function() { return number(d["0"]) + " notti";}, other: function() { return number(d["0"]) + " notti";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b223119328 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1491819313 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2065230702 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi date"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b804897775 = messageFormatterFn((function(  ) {
  return function(d) { return "Fatto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2032473481 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1628116499 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifica la data di check-in nella tabella in basso."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1303475458 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifica la data di check-out nella tabella in basso."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1965801549 = messageFormatterFn((function(  ) {
  return function(d) { return "selezionato."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1718508954 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + ". Chiudi il calendario o procedi per cambiare la data selezionata."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1787501278 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + " " + d["1"] + ". Chiudi il calendario o procedi per cambiare le date selezionate."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1140652008 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + ". Il prezzo è " + d["1"] + ". Chiudi il calendario o procedi per cambiare la data selezionata."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1237722096 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + " " + d["1"] + ". Il prezzo è " + d["2"] + ". Chiudi il calendario o procedi per cambiare le date selezionate."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1520038775 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona la data di check-in"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1115725456 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona la data di check-out"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b74297633 = messageFormatterFn((function(  ) {
  return function(d) { return "nessuna data"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1929755645 = messageFormatterFn((function(  ) {
  return function(d) { return "Mese scorso"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1465753375 = messageFormatterFn((function(  ) {
  return function(d) { return "Mese prossimo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b273617266 = messageFormatterFn((function(  ) {
  return function(d) { return "Passa al pulsante " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1828310810 = messageFormatterFn((function(  ) {
  return function(d) { return "Dal giorno " + d["0"] + " al giorno " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1222387031 = messageFormatterFn((function(  ) {
  return function(d) { return "Le date sono state cancellate"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1067190902 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " risultati trovati";}, one: function() { return number(d["0"]) + " risultato trovato";}, two: function() { return number(d["0"]) + " risultati trovati";}, few: function() { return number(d["0"]) + " risultati trovati";}, many: function() { return number(d["0"]) + " risultati trovati";}, other: function() { return number(d["0"]) + " risultati trovati";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1242605759 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "“" + d["0"] + "” " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return "Ci sono " + number(d["1"]) + " risultati disponibili";}, one: function() { return "C’è " + number(d["1"]) + " risultato disponibile";}, two: function() { return "Ci sono " + number(d["1"]) + " risultati disponibili";}, few: function() { return "Ci sono " + number(d["1"]) + " risultati disponibili";}, many: function() { return "Ci sono " + number(d["1"]) + " risultati disponibili";}, other: function() { return "Ci sono " + number(d["1"]) + " risultati disponibili";} }) + ". Usa le frecce o scorri per spostarti nell’elenco."; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1315143565 = messageFormatterFn((function(  ) {
  return function(d) { return "Il campo “" + d["0"] + "” è attivo. Inserisci un termine per la ricerca."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a648575324 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai selezionato " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a176689081 = messageFormatterFn((function(  ) {
  return function(d) { return "Il menu si è chiuso."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1322487425 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Il campo di ricerca “" + d["0"] + "” è attivo, al momento " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, one: function() { return "c’è " + number(d["1"]) + " suggerimento";}, two: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, few: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, many: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, other: function() { return "ci sono " + number(d["1"]) + " suggerimenti";} }) + " per “" + d["2"] + "”. Passa alla lista."; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b2099440424 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Il campo di ricerca “" + d["0"] + "” è attivo, " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, one: function() { return "c’è " + number(d["1"]) + " suggerimento";}, two: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, few: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, many: function() { return "ci sono " + number(d["1"]) + " suggerimenti";}, other: function() { return "ci sono " + number(d["1"]) + " suggerimenti";} }) + ". Inserisci un termine per la ricerca o passa alla lista."; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a1909779756 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Il campo di ricerca “" + d["0"] + "” è attivo, al momento hai selezionato \"" + d["1"] + "\". " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return "Ci sono " + number(d["1"]) + " suggerimenti";}, one: function() { return "C’è " + number(d["1"]) + " suggerimento";}, two: function() { return "Ci sono " + number(d["1"]) + " suggerimenti";}, few: function() { return "Ci sono " + number(d["1"]) + " suggerimenti";}, many: function() { return "Ci sono " + number(d["1"]) + " suggerimenti";}, other: function() { return "Ci sono " + number(d["1"]) + " suggerimenti";} }) + " per “" + d["3"] + "”. Passa alla lista."; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a783537210 = messageFormatterFn((function(  ) {
  return function(d) { return "Fatto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1737030607 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulla tutto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b185223804 = messageFormatterFn((function(  ) {
  return function(d) { return "Opzioni selezionate"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1821291985 = messageFormatterFn((function(  ) {
  return function(d) { return "È stata eliminata l’opzione: " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1728627544 = messageFormatterFn((function(  ) {
  return function(d) { return "Sono state eliminate le opzioni selezionate."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b192296503 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai compilato il campo di inserimento del testo. Effettua la ricerca o seleziona una delle categorie consigliate."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2110685526 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerca “" + d["0"] + "”"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b220702231 = messageFormatterFn((function(  ) {
  return function(d) { return "Nessun risultato per “" + d["0"] + "”"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1967310721 = messageFormatterFn((function(  ) {
  return function(d) { return "Aeroporto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1851928936 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b513601858 = messageFormatterFn((function(  ) {
  return function(d) { return "Luogo di interesse"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1152843111 = messageFormatterFn((function(  ) {
  return function(d) { return "Vicino a"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1251821980 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova con “" + d["0"] + "”"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b197563007 = messageFormatterFn((function(  ) {
  return function(d) { return "Regione/Città"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a159742539 = messageFormatterFn((function(  ) {
  return function(d) { return "Aeroporto"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1224330179 = messageFormatterFn((function(  ) {
  return function(d) { return "Attrazione"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1515686348 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a543527732 = messageFormatterFn((function(  ) {
  return function(d) { return "Indirizzo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1423478046 = messageFormatterFn((function(  ) {
  return function(d) { return "Stazione ferroviaria"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a603101937 = messageFormatterFn((function(  ) {
  return function(d) { return "Stazione della metropolitana"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1308024533 = messageFormatterFn((function(  ) {
  return function(d) { return "Località nelle vicinanze"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1394488276 = messageFormatterFn((function(  ) {
  return function(d) { return "Le tue ultime ricerche"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b473870086 = messageFormatterFn((function(  ) {
  return function(d) { return "Cos’altro hanno cercato i viaggiatori"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1149010629 = messageFormatterFn((function(  ) {
  return function(d) { return "Le destinazioni più richieste"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b950483751 = messageFormatterFn((function(  ) {
  return function(d) { return "Le destinazioni più gettonate"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1635259133 = messageFormatterFn((function(  ) {
  return function(d) { return "Le destinazioni del momento"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a54187909 = messageFormatterFn((function(  ) {
  return function(d) { return "La tua posizione"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a194418562 = messageFormatterFn((function(  ) {
  return function(d) { return "Condivisione posizione disattivata"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1229233778 = messageFormatterFn((function(  ) {
  return function(d) { return "Non siamo in grado di stabilire la tua posizione. Inserisci il nome della destinazione o attiva la funzione di geolocalizzazione sul tuo dispositivo."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1175795754 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " camere";}, one: function() { return number(d["0"]) + " camera";}, two: function() { return number(d["0"]) + " camere";}, few: function() { return number(d["0"]) + " camere";}, many: function() { return number(d["0"]) + " camere";}, other: function() { return number(d["0"]) + " camere";} }) + ", " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]) + " persone";}, one: function() { return number(d["1"]) + " persona";}, two: function() { return number(d["1"]) + " persone";}, few: function() { return number(d["1"]) + " persone";}, many: function() { return number(d["1"]) + " persone";}, other: function() { return number(d["1"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a642625728 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " persone";}, one: function() { return number(d["0"]) + " persona";}, two: function() { return number(d["0"]) + " persone";}, few: function() { return number(d["0"]) + " persone";}, many: function() { return number(d["0"]) + " persone";}, other: function() { return number(d["0"]) + " persone";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b1187733724 = messageFormatterFn((function(  ) {
  return function(d) { return "Il valore del campo " + d["0"] + " è ora " + d["1"] + ". Il valore del campo " + d["2"] + " è ora " + d["3"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b483973997 = messageFormatterFn((function(  ) {
  return function(d) { return "Inverti i campi " + d["0"] + " e " + d["1"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b575387712 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra password"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b889729851 = messageFormatterFn((function(  ) {
  return function(d) { return "Nascondi password"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b772576706 = messageFormatterFn((function(  ) {
  return function(d) { return "Scheda attuale: " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a46085527 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " su " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1177498751 = messageFormatterFn((function(  ) {
  return function(d) { return "Foto " + d["0"] + " di " + d["1"] + ". " + d["2"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b161378116 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra immagine successiva"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a224157624 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra immagine precedente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a663369762 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Mostra " + plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " immagini";}, one: function() { return number(d["0"]) + " immagine";}, two: function() { return number(d["0"]) + " immagini";}, few: function() { return number(d["0"]) + " immagini";}, many: function() { return number(d["0"]) + " immagini";}, other: function() { return number(d["0"]) + " immagini";} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b357986413 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Mostra " + plural(d["0"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["0"]) + " immagini";}, 1: function() { return "un’immagine";}, two: function() { return number(d["0"]) + " immagini";}, few: function() { return number(d["0"]) + " immagini";}, many: function() { return number(d["0"]) + " immagini";}, other: function() { return number(d["0"]) + " immagini";} }) + " per " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.a847069648 = messageFormatterFn((function(  ) {
  return function(d) { return "Completato:"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1934106626 = messageFormatterFn((function(  ) {
  return function(d) { return "Stato attuale:"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1491455148 = messageFormatterFn((function(  ) {
  return function(d) { return "Fase " + d["0"] + " di " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a885258480 = messageFormatterFn((function(  ) {
  return function(d) { return "Fase " + d["0"] + " di " + d["1"] + ":"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a374524849 = messageFormatterFn((function(  ) {
  return function(d) { return "Foto " + d["0"] + " di " + d["1"] + ". " + d["2"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1065005970 = messageFormatterFn((function(  ) {
  return function(d) { return "Immagine successiva"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1660351082 = messageFormatterFn((function(  ) {
  return function(d) { return "Immagine precedente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a497387652 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "; espandi per vedere i dettagli a schermo intero"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1791532688 = messageFormatterFn((function(  ) {
  return function(d) { return "Miniatura " + d["0"] + "; espandi per vedere i dettagli a schermo intero"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1944887270 = messageFormatterFn((function(  ) {
  return function(d) { return "Pagina attuale"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b864110250 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra altre pagine"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b901931366 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra meno pagine"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1571133373 = messageFormatterFn((function(  ) {
  return function(d) { return "Caricamento in corso: " + d["0"] + " percento"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a71666680 = messageFormatterFn((function(  ) {
  return function(d) { return "Caricamento in corso"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a972760248 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b430730993 = messageFormatterFn((function(  ) {
  return function(d) { return "Si è verificato un errore."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b90112845 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova a guardare il video su YouTube o attiva JavaScript nel tuo browser (nel caso in cui fosse disattivato)."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1330013989 = messageFormatterFn((function(  ) {
  return function(d) { return "Avvia il video"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1824943083 = messageFormatterFn((function(  ) {
  return function(d) { return "Metti in pausa il video"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1651627069 = messageFormatterFn((function(  ) {
  return function(d) { return "Caricamento del video in corso"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1747340103 = messageFormatterFn((function(  ) {
  return function(d) { return "Immagine a 360 gradi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1293411789 = messageFormatterFn((function(  ) {
  return function(d) { return "Questa è un’immagine a 360 gradi. Usa i tasti control e le frecce o il tasto comando e le frecce per spostarti."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2071480378 = messageFormatterFn((function(  ) {
  return function(d) { return "L’immagine mostrata al momento è: " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a274189413 = messageFormatterFn((function(  ) {
  return function(d) { return "Spostamento a sinistra completato. Posizione: " + d["0"] + " gradi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1055151700 = messageFormatterFn((function(  ) {
  return function(d) { return "Spostamento a destra completato. Posizione: " + d["0"] + " gradi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b996085063 = messageFormatterFn((function(  ) {
  return function(d) { return "Spostamento in alto completato"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a54892096 = messageFormatterFn((function(  ) {
  return function(d) { return "Spostamento in basso completato"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2089698287 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto la parte superiore dell’immagine"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1830752295 = messageFormatterFn((function(  ) {
  return function(d) { return "Hai raggiunto la parte inferiore dell’immagine"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a472330619 = messageFormatterFn((function(  ) {
  return function(d) { return "Seleziona tutte le righe"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b411695782 = messageFormatterFn((function(  ) {
  return function(d) { return "Deseleziona tutte le righe"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1342036074 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra le voci della colonna in ordine decrescente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b432919684 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostra le voci della colonna in ordine crescente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2143973300 = messageFormatterFn((function(  ) {
  return function(d) { return "Ora le voci della colonna sono mostrate in ordine decrescente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a2002499804 = messageFormatterFn((function(  ) {
  return function(d) { return "Ora le voci della colonna sono mostrate in ordine crescente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1520524116 = messageFormatterFn((function(  ) {
  return function(d) { return "Espandi la riga " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a844900821 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Numero di opzioni mostrate: " + d["0"] + " su " + plural(d["1"], 0, pluralFuncs["it-CH"], { zero: function() { return number(d["1"]);}, one: function() { return number(d["1"]);}, two: function() { return number(d["1"]);}, few: function() { return number(d["1"]);}, many: function() { return number(d["1"]);}, other: function() { return number(d["1"]);} }); }
})(messageFormat.number, messageFormat.plural, {"it-CH": Globalize("it-CH").pluralGenerator()}), Globalize("it-CH").pluralGenerator({}));
Globalize.b106682203 = messageFormatterFn((function(  ) {
  return function(d) { return "i mesi mostrati al momento sono " + d["0"] + " " + d["1"] + " e " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a661962173 = messageFormatterFn((function(  ) {
  return function(d) { return "il mese mostrato al momento è " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b408177544 = messageFormatterFn((function(  ) {
  return function(d) { return "i mesi mostrati al momento vanno da " + d["0"] + " " + d["1"] + " a " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b515951283 = messageFormatterFn((function(  ) {
  return function(d) { return "La data di check-in è stata rimossa."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a777160234 = messageFormatterFn((function(  ) {
  return function(d) { return "La data di check-out è stata rimossa."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1632408267 = messageFormatterFn((function(  ) {
  return function(d) { return "Le date sono state rimosse."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1790387120 = messageFormatterFn((function(  ) {
  return function(d) { return "Rimuovi date"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1396934992 = messageFormatterFn((function(  ) {
  return function(d) { return "Invia"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b151383021 = messageFormatterFn((function(  ) {
  return function(d) { return "Mese successivo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a303815507 = messageFormatterFn((function(  ) {
  return function(d) { return "Mese precedente"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1130180487 = messageFormatterFn((function(  ) {
  return function(d) { return "Passa al pulsante Invia"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a231296556 = messageFormatterFn((function(  ) {
  return function(d) { return "Passa al pulsante " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a982852099 = messageFormatterFn((function(  ) {
  return function(d) { return "Mese successivo"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b307371325 = messageFormatterFn((function(  ) {
  return function(d) { return "Mese precedente "; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1700767348 = messageFormatterFn((function(  ) {
  return function(d) { return "Il giorno " + d["0"] + " è stato selezionato come data di check-in."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b269015985 = messageFormatterFn((function(  ) {
  return function(d) { return "Il giorno " + d["0"] + " è stato selezionato come data di check-out."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a774333608 = messageFormatterFn((function(  ) {
  return function(d) { return "Il giorno " + d["0"] + " non è una data di check-in valida."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1344464227 = messageFormatterFn((function(  ) {
  return function(d) { return "Il giorno " + d["0"] + " non è una data di check-out valida."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1222324596 = messageFormatterFn((function(  ) {
  return function(d) { return "Nessuna disponibilità in data " + d["0"] + "."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1020475611 = messageFormatterFn((function(  ) {
  return function(d) { return "Oggi"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1470738845 = messageFormatterFn((function(  ) {
  return function(d) { return "Data di check-in selezionata"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b2024846378 = messageFormatterFn((function(  ) {
  return function(d) { return "Data di check-out selezionata"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1599699105 = messageFormatterFn((function(  ) {
  return function(d) { return "Data selezionata"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1137083963 = messageFormatterFn((function(  ) {
  return function(d) { return "Dal"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1166411852 = messageFormatterFn((function(  ) {
  return function(d) { return "Al"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1873153909 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancella, chiudi il calendario senza salvare le modifiche. O seleziona una data dalla tabella in basso."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1371960358 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " su " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a1703830491 = messageFormatterFn((function(  ) {
  return function(d) { return "Premi il tasto Esc per chiudere il menu."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a549170692 = messageFormatterFn((function(  ) {
  return function(d) { return "Premi il tasto Esc per comprimere il menu."; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1181371629 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci un numero inferiore a " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a844377038 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci un numero maggiore di " + d["0"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1544681915 = messageFormatterFn((function(  ) {
  return function(d) { return "Inserisci un numero compreso tra " + d["0"] + " e " + d["1"]; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.a664687500 = messageFormatterFn((function(  ) {
  return function(d) { return "Obbligatorio"; }
})(), Globalize("it-CH").pluralGenerator({}));
Globalize.b1175393518 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a2005027410 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b665083099 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1787537057 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a2059168434 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a2083587367 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b438076846 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a2113309458 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1652163566 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b906654491 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1340748466 = dateToPartsFormatterFn({"2":Globalize("it-CH").numberFormatter({"raw":"00"}),"4":Globalize("it-CH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1044831731 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"D","mon":"L","tue":"M","wed":"M","thu":"G","fri":"V","sat":"S"}}}});
Globalize.a381906898 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"domenica","mon":"lunedì","tue":"martedì","wed":"mercoledì","thu":"giovedì","fri":"venerdì","sat":"sabato"}}}});
Globalize.b871338542 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.a850786382 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1871596741 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"}),"2":Globalize("it-CH").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a783890396 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.b1488562643 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b1138747864 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b2115004424 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"gennaio","2":"febbraio","3":"marzo","4":"aprile","5":"maggio","6":"giugno","7":"luglio","8":"agosto","9":"settembre","10":"ottobre","11":"novembre","12":"dicembre"}}}});
Globalize.b2114319231 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.b2082209252 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"domenica","mon":"lunedì","tue":"martedì","wed":"mercoledì","thu":"giovedì","fri":"venerdì","sat":"sabato"}}},"months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.b1495950811 = dateToPartsFormatterFn({"1":Globalize("it-CH").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"dom","mon":"lun","tue":"mar","wed":"mer","thu":"gio","fri":"ven","sat":"sab"}}},"months":{"M":{"3":{"1":"gen","2":"feb","3":"mar","4":"apr","5":"mag","6":"giu","7":"lug","8":"ago","9":"set","10":"ott","11":"nov","12":"dic"}}}});
Globalize.b796679767 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1911226135 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1149834108 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a27380150 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1857085111 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b396462722 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b59363095 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1802944087 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1273449815 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a908262716 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1719462217 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1196005098 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b454253655 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1707499095 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a1434069975 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"d"}));
Globalize.a1480189660 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1211748965 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1109848892 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a2011443825 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1736290673 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1735605480 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1595027493 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1117237060 = dateFormatterFn(Globalize("it-CH").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a817381976 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b297164392 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a360453099 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b762000859 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b243023368 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1185843731 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1554698648 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b188882344 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a340611928 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a118881707 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b961443336 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a610129671 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^D/],["mon",/^L/],["tue",/^M/],["wed",/^M/],["thu",/^G/],["fri",/^V/],["sat",/^S/]]});
Globalize.b1365822568 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^mercoledì/],["sun",/^domenica/],["tue",/^martedì/],["thu",/^giovedì/],["fri",/^venerdì/],["mon",/^lunedì/],["sat",/^sabato/]]});
Globalize.a1675899288 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.b123717048 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1635792651 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1784225834 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
Globalize.a504212851 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.a507750306 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.b122228930 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^settembre/],["2",/^febbraio/],["11",/^novembre/],["12",/^dicembre/],["1",/^gennaio/],["10",/^ottobre/],["4",/^aprile/],["5",/^maggio/],["6",/^giugno/],["7",/^luglio/],["8",/^agosto/],["3",/^marzo/]]});
Globalize.b121543737 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
Globalize.b345432810 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^mercoledì/],["sun",/^domenica/],["tue",/^martedì/],["thu",/^giovedì/],["fri",/^venerdì/],["mon",/^lunedì/],["sat",/^sabato/]],"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
Globalize.a496824683 = dateParserFn(Globalize("it-CH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^dom/],["mon",/^lun/],["tue",/^mar/],["wed",/^mer/],["thu",/^gio/],["fri",/^ven/],["sat",/^sab/]],"gregorian/months/format/abbreviated":[["1",/^gen/],["2",/^feb/],["3",/^mar/],["4",/^apr/],["5",/^mag/],["6",/^giu/],["7",/^lug/],["8",/^ago/],["9",/^set/],["10",/^ott/],["11",/^nov/],["12",/^dic/]]});
module.exports = Globalize;
